import cc from "classcat"

export default function Tag({ text, theme = "dark", className }) {
  return (
    <p
      className={cc([
        "m-0 my-2 block w-max rounded-full px-4 py-2 text-sm font-bold",
        className,
        {
          "bg-kkm-green text-white": theme === "dark",
          "bg-kkm-darkgreen text-white": theme === "light",
          "bg-kkm-yellow text-zinc-800": theme === "green-yellow",
        },
      ])}
    >
      {text}
    </p>
  )
}
